module.exports = __webpack_public_path__ + "static/media/nSkvej1E8x.1b9c7b2d.jpg";